export const PlusIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262E3D"
        fillOpacity="0.67"
        d="M12 12V7.5a.5.5 0 1 0-1 0V12H6.5a.5.5 0 1 0 0 1H11v4.5a.5.5 0 1 0 1 0V13h4.5a.5.5 0 1 0 0-1H12z"
      ></path>
    </svg>
  );
};
